import _slicedToArray from "/builds/V9wkxyNh/1/ifood/enterprise/apis/benf-companies-developer-portal/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.reduce-right.js";
import * as React from 'react';
var __reactCreateElement__ = React.createElement;
import * as ReactDOM from 'react-dom';
export var PORTALS = {};

var getContainer = function getContainer(container) {
  return typeof document !== 'undefined' && document.querySelectorAll(container);
};

function _ref(children, _ref2) {
  var provider = _ref2.provider,
      value = _ref2.value;
  return __reactCreateElement__(provider, {
    value: value
  }, children);
}

var Portalize = function Portalize(_ref3) {
  var _ref3$container = _ref3.container,
      container = _ref3$container === void 0 ? '#portals' : _ref3$container,
      _ref3$server = _ref3.server,
      server = _ref3$server === void 0 ? true : _ref3$server,
      providers = _ref3.providers,
      children = _ref3.children;

  var _React$useState = React.useState(getContainer(container)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      nodes = _React$useState2[0],
      setNodes = _React$useState2[1];

  React.useEffect(function () {
    setNodes(getContainer(container));
  }, [container]);

  if (nodes === false) {
    // this branch only renders on the server
    if (server) {
      if (providers !== void 0 && providers.length > 0) {
        children = providers.reduceRight(_ref, children);
      }

      if (children) PORTALS[container] = children;
    }
  } else if (nodes.length > 0) {
    var portals = [];

    for (var i = 0; i < nodes.length; i++) {
      portals.push( /*#__PURE__*/ReactDOM.createPortal(children, nodes[i]));
    }

    return /*#__PURE__*/__reactCreateElement__(React.Fragment, null, portals);
  }

  return null;
};

export default Portalize;